import type { AppShellSchema } from "../types/schema";

export const defaultAppShell: AppShellSchema = {
  type: "appShell",
  appName: {
    en: "EtheraGuru",
    hi: "एथेरागुरु",
  },
  navigation: [],
  chatEnabled: true,
};
